import React, { Component } from "react";
import NavMenu from "../components/Nav";
import { Link } from "react-router-dom";
import logo from "../logo.png";

export default class Header extends Component {
  render() {
    return (
      <header className="App-header front-end-header clearfix">
        <div className="top-header clearfix">
          <div className="top-header-content large-wrapper">
            <div className="col-xs-12 col-sm-5 col-lg-6 top-header-left">
              <h1 className="top-header-title">Minerva Web Development</h1>
            </div>
            <div className="col-xs-12 col-sm-7 col-lg-6 top-header-right">
              <p>
                <a className="contact-header" href="tel:+1-716-406-7548">
                  <i className="fas fa-mobile-alt" /> (716) 406-7548
                </a>
                <a
                  className="contact-header"
                  href="mailto:info@minervawebdevelopment.com"
                >
                  <i className="far fa-envelope" />
                  info@minervawebdevelopment.com
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="header-content wrap">
          <div className="col-xs-12 col-sm-4">
            <Link to="/">
              <img src={logo} className="App-logo " alt="logo" />
            </Link>
          </div>
          <NavMenu />
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/includes/Header.js